import ListField from './ListField'
const Projects = props => (
   <ListField
      {...props}
      label="Projects"
      fieldKey="projects"
      placeholder="Project name or description…"
   />
)
export default Projects
